const bangladeshConfig ={
  production: {
    hostname: 'https://api.dominos.com.bd',
    GOOGLE_CLIENT_ID: '928101681689-ff7osdtgn62jijcpf4odfqara5rhoa8n.apps.googleusercontent.com', // TODO: replace LOCAL clientID with Production CLientID ( create new on https://console.developers.google.com/apis/credentials?project=dominosbd-f6f05&authuser=1 )
    FACEBOOK_APP_ID: '340424936572374',
    API_KEY: 'd2aeb489bb8df385',
    DESKTOP_API_KEY: 'd2aeb489bb8df385',
    GTM_TAG: 'GTM-NBJ4SNZ8',
    domain: 'https://m.dominos.com.bd',
    agent_domain: 'https://agent.dominos.com.bd',
    CLEVERTAP_ID: 'TEST-Z6K-Z99-W85Z', //W6K-Z99-W85Z
    CLIENT_TYPE: 'web app-chrome',
    AMPLITUDE_API_KEY: '9481c67307638bee6bbdaaa2bfcb2750',
    AMPLITUDE_API_KEY_PWA: '9481c67307638bee6bbdaaa2bfcb2750',
    AMPLITUDE_INSTANCE_NAME: 'Dominos-BD-PWA-Production',
    APP_INSTANCE: '71346f376e396231',
    VWO_ACCOUNT_ID: '639135',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    WAF_API_KEY: '26df4d5fff00'
  },
  beta: {
    hostname: 'https://bg-prod-api.dominosindia.in',
    GOOGLE_CLIENT_ID: '928101681689-ff7osdtgn62jijcpf4odfqara5rhoa8n.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '755213058282927',
    API_KEY: '5dc22c0253f499ac',
    DESKTOP_API_KEY: '5dc22c0253f499ac',
    GTM_TAG: 'GTM-KRLDLJQ',
    domain: 'https://bg-prod-new-pwa.dominosindia.in',
    agent_domain: 'https://agent.dominos.com.bd',
    CLIENT_TYPE: 'web app-chrome',
    AMPLITUDE_API_KEY: '9481c67307638bee6bbdaaa2bfcb2750',
    AMPLITUDE_API_KEY_PWA: '9481c67307638bee6bbdaaa2bfcb2750',
    AMPLITUDE_INSTANCE_NAME: 'Dominos-BD-PWA-Production',
    APP_INSTANCE: '71346f376e396231',
    VWO_ACCOUNT_ID: '639135',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    WAF_API_KEY: '26df4d5fff00'
  },
  uat: {
    hostname: 'https://api.dominos.com.bd',
    GOOGLE_CLIENT_ID: '928101681689-ff7osdtgn62jijcpf4odfqara5rhoa8n.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '755213058282927',
    API_KEY: '7369702fc2a34276',
    DESKTOP_API_KEY: '7369702fc2a34276',
    GTM_TAG: 'GTM-KRLDLJQ',
    domain: 'https://m.dominos.com.bd',
    agent_domain: 'https://agent.dominos.com.bd',
    CLIENT_TYPE: 'web app-chrome',
    AMPLITUDE_API_KEY: '9481c67307638bee6bbdaaa2bfcb2750',
    AMPLITUDE_API_KEY_PWA: '9481c67307638bee6bbdaaa2bfcb2750',
    AMPLITUDE_INSTANCE_NAME: 'Dominos-BD-PWA-Production',
    APP_INSTANCE: '71346f376e396231',
    VWO_ACCOUNT_ID: '639135',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    WAF_API_KEY: '26df4d5fff00'
  },
  stage: {
    hostname: 'https://api.dominos.com.bd',
    GOOGLE_CLIENT_ID: '928101681689-ff7osdtgn62jijcpf4odfqara5rhoa8n.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '755213058282927',
    API_KEY: 'd2aeb489bb8df385',
    DESKTOP_API_KEY: 'd2aeb489bb8df385',
    GTM_TAG: 'GTM-NK4RX25',
    domain: 'https://m.dominos.com.bd',
    agent_domain: 'https://agent.dominos.com.bd',
    CLIENT_TYPE: 'web app-chrome',
    AMPLITUDE_API_KEY: '6b03126e8d3c34b796c80edcdc099fef',
    AMPLITUDE_API_KEY_PWA: '6b03126e8d3c34b796c80edcdc099fef',
    AMPLITUDE_INSTANCE_NAME: 'Test-Dominos-BD-PWA',
    APP_INSTANCE: '71346f376e396231',
    VWO_ACCOUNT_ID: '639135',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    WAF_API_KEY: 'aa8c247c2076'
  },
  stage1: {
    hostname: 'https://bd-s1-labs.dominosindia.in',
    GOOGLE_CLIENT_ID: '928101681689-ff7osdtgn62jijcpf4odfqara5rhoa8n.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '340424936572374',
    API_KEY: '5dc22c0253f499ac',
    DESKTOP_API_KEY: '5dc22c0253f499ac',
    GTM_TAG: 'GTM-NBJ4SNZ8', // 'GTM-NK4RX25', // old prod gtmid - GTM-KRLDLJQ
    domain: 'https://s1-bgcsr-pwa.dominosindia.in',
    agent_domain: 'https://agent.dominos.com.bd',
    CLIENT_TYPE: 'web app-chrome',
    AMPLITUDE_API_KEY: '6b03126e8d3c34b796c80edcdc099fef',
    AMPLITUDE_API_KEY_PWA: '6b03126e8d3c34b796c80edcdc099fef',
    AMPLITUDE_INSTANCE_NAME: 'Test-Dominos-BD-PWA',
    APP_INSTANCE: '71346f376e396231',
    VWO_ACCOUNT_ID: '639135',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    WAF_API_KEY: 'aa8c247c2076'
  },
  development: {
    hostname: 'https://bg-api.dominosindia.in',
    GOOGLE_CLIENT_ID: '928101681689-ff7osdtgn62jijcpf4odfqara5rhoa8n.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '755213058282927',
    API_KEY: '5dc22c0253f499ac',
    DESKTOP_API_KEY: '5dc22c0253f499ac',
    GTM_TAG: 'GTM-NK4RX25',
    domain: 'http://bgpwa-dev0.dominosindia.in',
    agent_domain: 'https://agent.dominos.com.bd',
    CLIENT_TYPE: 'web app-chrome',
    AMPLITUDE_API_KEY: '6b03126e8d3c34b796c80edcdc099fef',
    AMPLITUDE_API_KEY_PWA: '6b03126e8d3c34b796c80edcdc099fef',
    AMPLITUDE_INSTANCE_NAME: 'Test-Dominos-BD-PWA',
    APP_INSTANCE: '71346f376e396231',
    VWO_ACCOUNT_ID: '639135',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    WAF_API_KEY: 'aa8c247c2076'
  },
  development1: {
    hostname: 'https://bd-dev1-labs.dominosindia.in',
    GOOGLE_CLIENT_ID: '928101681689-ff7osdtgn62jijcpf4odfqara5rhoa8n.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '755213058282927',
    API_KEY: '5dc22c0253f499ac',
    DESKTOP_API_KEY: '5dc22c0253f499ac',
    GTM_TAG: 'GTM-NK4RX25',
    domain: 'https://bd-d1-csr-pwa.dominosindia.in/',
    agent_domain: 'https://agent.dominos.com.bd',
    CLIENT_TYPE: 'web app-chrome',
    AMPLITUDE_API_KEY: '6b03126e8d3c34b796c80edcdc099fef',
    AMPLITUDE_API_KEY_PWA: '6b03126e8d3c34b796c80edcdc099fef',
    AMPLITUDE_INSTANCE_NAME: 'Test-Dominos-BD-PWA',
    APP_INSTANCE: '71346f376e396231',
    VWO_ACCOUNT_ID: '639135',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    WAF_API_KEY: 'aa8c247c2076'
  },
  'bd-d1': {
    hostname: 'https://bd-dev1-labs.dominosindia.in',
    GOOGLE_CLIENT_ID: '928101681689-ff7osdtgn62jijcpf4odfqara5rhoa8n.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '755213058282927',
    API_KEY: '5dc22c0253f499ac',
    DESKTOP_API_KEY: '5dc22c0253f499ac',
    GTM_TAG: 'GTM-NK4RX25',
    domain: 'http://bgpwa-dev0.dominosindia.in',
    domain: 'https://bd-d1-csr-pwa.dominosindia.in/',
    agent_domain: 'https://agent.dominos.com.bd',
    CLIENT_TYPE: 'web app-chrome',
    AMPLITUDE_API_KEY: '6b03126e8d3c34b796c80edcdc099fef',
    AMPLITUDE_API_KEY_PWA: '6b03126e8d3c34b796c80edcdc099fef',
    APP_INSTANCE: '71346f376e396231',
    VWO_ACCOUNT_ID: '639135',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    WAF_API_KEY: 'aa8c247c2076'
  },
  development2: {
    hostname: 'https://api-bg-dev-2.dominosindia.in',
    GOOGLE_CLIENT_ID: '928101681689-ff7osdtgn62jijcpf4odfqara5rhoa8n.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '755213058282927',
    API_KEY: '5dc22c0253f499ac',
    DESKTOP_API_KEY: '5dc22c0253f499ac',
    GTM_TAG: 'GTM-NK4RX25',
    domain: 'https://bgpwa-dev2.dominosindia.in',
    agent_domain: 'https://agent.dominos.com.bd',
    CLIENT_TYPE: 'web app-chrome',
    AMPLITUDE_API_KEY: '6b03126e8d3c34b796c80edcdc099fef',
    AMPLITUDE_API_KEY_PWA: '6b03126e8d3c34b796c80edcdc099fef',
    AMPLITUDE_INSTANCE_NAME: 'Test-Dominos-BD-PWA',
    APP_INSTANCE: '71346f376e396231',
    VWO_ACCOUNT_ID: '639135',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    WAF_API_KEY: 'aa8c247c2076'
  },
  local: {
    hostname: 'https://api.dominos.com.bd',
    GOOGLE_CLIENT_ID: '928101681689-ff7osdtgn62jijcpf4odfqara5rhoa8n.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '468754413723874',
    API_KEY: 'cb66dd789fd1534f',
    DESKTOP_API_KEY: 'cb66dd789fd1534f',
    GTM_TAG: 'GTM-NK4RX25',
    domain: 'http://localhost:3000',
    agent_domain: 'http://localhost:3000',
    CLIENT_TYPE: 'web app-chrome',
    AMPLITUDE_API_KEY: '6b03126e8d3c34b796c80edcdc099fef',
    AMPLITUDE_API_KEY_PWA: '6b03126e8d3c34b796c80edcdc099fef',
    AMPLITUDE_INSTANCE_NAME: 'Test-Dominos-BD-PWA',
    APP_INSTANCE: '71346f376e396231',
    VWO_ACCOUNT_ID: '639135',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    WAF_API_KEY: 'aa8c247c2076'
  },
  local_stage: {
    hostname: 'https://api.dominos.com.bd',
    GOOGLE_CLIENT_ID: '928101681689-ff7osdtgn62jijcpf4odfqara5rhoa8n.apps.googleusercontent.com',
    FACEBOOK_APP_ID: '755213058282927',
    API_KEY: 'fd2ed7880af4bdd2',
    DESKTOP_API_KEY: 'fd2ed7880af4bdd2',
    GTM_TAG: 'GTM-NK4RX25',
    domain: 'https://m.dominos.com.bd',
    agent_domain: 'https://agent.dominos.com.bd',
    CLIENT_TYPE: 'web app-chrome',
    AMPLITUDE_API_KEY: '6b03126e8d3c34b796c80edcdc099fef',
    AMPLITUDE_API_KEY_PWA: '6b03126e8d3c34b796c80edcdc099fef',
    AMPLITUDE_INSTANCE_NAME: 'Test-Dominos-BD-PWA',
    APP_INSTANCE: '71346f376e396231',
    VWO_ACCOUNT_ID: '639135',
    ENC_DEC_SALT: '2Na@4Sr&8Qp&2NmLk$4Om&0Fe@9Dc#8Ba',
    WAF_API_KEY: 'aa8c247c2076'
  },
  image: {
    hostname: 'https://images.dominos.com.bd/',
  },
  s3Bucket: {
    production: 'olo-bg-prod-api',
    beta: 'olo-bg-prod-api',
    development: 'olo-bg-dev-api',
    development1: 'olo-bg-dev-api',
    development2: 'stage-olo-api-bucket',
    local: 'olo-bg-prod-api', //'olo-bg-dev-api',
    stage: 'olo-bg-prod-api', //'olo-bg-dev-api',
    stage1:'bd-s1-olo-api',
    local_stage: 'olo-bg-prod-api', //'olo-bg-dev-api',
    uat: 'olo-bg-prod-api',
  },
  cmsSiteBucket: {
    production: 'jflcms',
    development: 'jflcms',
    development1: 'jflcms',
    devcsr: 'jflcms',
    local: 'jflcms',
    dev0: 'jflcms',
    dev2: 'jflcms',
    dev4: 'jflcms',
    dev6: 'jflcms',
    stage: 'jflcms-s0',
    stage2: 'jflcms-s2',
    stage3: 'jflcms',
    stage4: 'jflcms-s4',
    stage6: 'jflcms-s6',
    stage7: 'jflcms-s7',
    stage8: 'jflcms-s8',
    stage9: 'jflcms-s9',
    stage1: 'jflcms-s1',
    local_stage: 'jflcms-s0',
    uat: 'jflcms',
  },
  staticAsset: '/static/assets',
  staticIcon: '/static/assets/icons',
  map: {
    autoComplete: 'https://maps.googleapis.com/maps/api/place/autocomplete/json?components=country:in&region=en&key=AIzaSyDSo8kVS5Q-2YSGRxrK2LHTeSApG4SNnmU&userId=2172&input=',
  },
};

module.exports = bangladeshConfig;
